import { Rendo, Undo } from "../../SVGasComponent";
import styles from "./undoRendoBlock.module.scss";

export const UndoRendoBlock = () => {
    //TODO включить когда появиться функционал
    return (
        <div className={styles.main}>
            {/* <div className={styles.circle}>
                <Undo />
            </div>
            <div className={styles.circle}>
                <Rendo />
            </div> */}

        </div>

    )
}